/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

import {
    REQUEST_UPDATE_USER_ACCESS_MENU,
    REQUEST_UPDATE_USER_ACCESS_MENU_FAILURE,
    REQUEST_UPDATE_USER_ACCESS_MENU_SUCCESS
} from "../../constant/UserAccessMenuConstant";

const initialState = {
    updateUserAccessMenu: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const updateUserAccessMenuReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_UPDATE_USER_ACCESS_MENU:
            return {
                ...state,
                updateUserAccessMenu: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_UPDATE_USER_ACCESS_MENU_SUCCESS:
            return {
                ...state,
                updateUserAccessMenu: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_UPDATE_USER_ACCESS_MENU_FAILURE:
            return {
                ...state,
                updateUserAccessMenu: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
